<template>
  <div class="finance-base-bill bank-flow-bill bottom-space">
    <div class="header">
      <div class="btn-container">
        <div
          v-if="curAuth.includes('total')"
          class="money"
        >
          <div class="key">{{totalLabel}}：</div>
          <div class="val">￥{{total}}</div>
        </div>
      </div>
    </div>
    <custom-table
      :slots="['action']"
      class="bill-list"
      tableCode="portal_finance_bank_flow"
      :data="data"
      @filter="filterChange"
      @sort="sortChange"
      :filterArr="filterArr"
    >
      <template
        v-if="showAction"
        v-slot:action="scope"
      >
        <span></span>
        <el-button
          v-if="curAuth.includes('del')"
          type="text"
          size="mini"
          @click="del(scope)"
        >{{ $t('Common.com_delete') }}</el-button>
      </template>
    </custom-table>
    <!-- <div class="footer">
      <div class="rest">
        <el-checkbox v-model="isRest">
          使用租赁结余暂收款
          <span class="price">￥300.00</span>
        </el-checkbox>
      </div>
      <div class="total">
        <div class="key">收款金额合计：</div>
        <div class="val">￥10,780.00</div>
      </div>
    </div>-->
    <div class="footer">
      <div
        v-if="curAuth.includes('billFlowSum')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.lsjexj') }}</div>
        <div class="val">￥{{billFlowSum}}</div>
      </div>
      <div
        v-if="curAuth.includes('cashSum')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.xian_jin_xiao_ji') }}</div>
        <div class="val">￥{{cashSum}}</div>
      </div>
      <div
        v-if="curAuth.includes('rentRest')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.zu_jin_yu_e') }}</div>
        <div class="val">￥{{rentRest}}</div>
      </div>
      <div
        v-if="curAuth.includes('confirmReceive')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.bcqrsk') }}</div>
        <div class="val">￥{{confirmReceive}}</div>
      </div>
      <div
        v-if="curAuth.includes('actualReceive')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.shi_shou_jin_e') }}</div>
        <div class="val">￥{{actualReceive}}</div>
      </div>
      <div
        v-if="curAuth.includes('actualPay')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.shi_fu_jin_e') }}</div>
        <div class="val">￥{{actualReceive}}</div>
      </div>
      <div
        v-if="curAuth.includes('addRest')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.ben_ci_zeng_jia_yu_e') }}</div>
        <div class="val">￥{{addRest}}</div>
      </div>
      <div
        v-if="curAuth.includes('restRentAmount')"
        class="total"
      >
        <div class="key">{{ $t('bank_flow_bill.sheng_yu_zu_lin_yu_e') }}</div>
        <div class="val">￥{{restRentAmount}}</div>
      </div>
    </div>
  </div>
</template>

<script>
/** 银行流水 */

import billMixin from './billMixin';

export default {
  name: '',
  mixins: [billMixin],
  components: {},
  props: {
    // 应收款账单信息-权限:addRest,restRentAmount 时需要传入
    orderViewList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 收款信息列表-权限：tradeSum，cashSum 时，必填
    tradeBoList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 计算余额必填
    balance: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      tableList: [],
      fullAuth: [
        // 删除
        'del',
        // 流水金额小记
        'billFlowSum',
        // 现金小计
        'cashSum',
        // 租金余额
        'rentRest',
        // 本次确认收款
        'confirmReceive',
        // 实收金额
        'actualReceive',
        // 实付金额
        'actualPay',
        // 本次增加余额
        'addRest',
        // 剩余租赁余额
        'restRentAmount',
        // 流水金额合计
        'total',
      ],
      showActionAuth: ['del'],
      defaultAuth: [],
      isRest: false
    };
  },
  computed: {
    totalLabel() {
      if (this.data.length) {
        if (this.dicCodeValue.payment_class) {
          const firstItem = this.data[0];
          if (`${firstItem.tradeMethod}` === `${this.dicCodeValue.payment_class.cash}`) {
            return this.$t('bank_flow_bill.xjzfjexj');
          } else {
            return this.$t('bank_flow_bill.dgzzjexj');
          }
        }
      }
      return this.$t('bank_flow_bill.liu_shui_jin_e_he_ji');
    },
    total() {
      return this.getTotal('totalAmount');
    },

    // 应收金额合计 shouldReceiveTotal 应收款账单信息的应收金额的sum
    shouldReceiveTotal() {
      const list = this.orderViewList;
      return list.reduce((total, item) => {
        const { paymentAmount = 0, breakAmount = 0, overdueAmount = 0, depositFee = 0 } = item;
        const sum = paymentAmount + breakAmount + overdueAmount + depositFee;
        return sum + total;
      }, 0);
    },
    /** 应收款账单信息 */
    // 交易金额小计  tradeSum   交易金额的sum
    tradeSum() {
      const tradeBoList = this.tradeBoList;
      return this.getTotal('totalAmount', tradeBoList);
    },
    // 预计本次使用余额  expectUseRest
    expectUseRest() {
      const tradeSum = this.tradeSum || 0;
      const shouldReceiveTotal = this.shouldReceiveTotal || 0;
      const balance = this.balance;
      if (tradeSum >= shouldReceiveTotal) {
        return 0;
      } else {
        const ret = ((shouldReceiveTotal - tradeSum) <= balance) ? shouldReceiveTotal - tradeSum : balance;
        return Math.max(ret, 0);
      }
    },
    /** 应收款账单信息 */


    // 流水金额小计 billFlowSum 流水金额的sum
    billFlowSum() {
      return this.getTotal('totalAmount');
    },
    // 现金小计 cashSum  收款信息中，交易类型为现金的 流水金额的sum
    cashSum() {
      // 收款信息列表
      const tradeBoList = this.tradeBoList;
      let ret = 0;
      tradeBoList.forEach((item) => {
        // 这里应该用字典，todo
        if (`${item.tradeMethod}` === '50') {
          ret += item.totalAmount;
        }
      });
      return ret;
    },
    // 租金余额 rentRest  -1 * expectUseRest
    rentRest() {
      const expectUseRest = this.expectUseRest || 0;
      return expectUseRest * -1;
    },
    // 本次确认收款 confirmReceive billFlowSum + cashSum + |rentRest|
    confirmReceive() {
      const billFlowSum = this.billFlowSum || 0;
      const cashSum = this.cashSum || 0;
      const rentRest = Math.abs(this.rentRest || 0);
      return billFlowSum + cashSum + rentRest;
    },
    // 实收金额 actualReceive   billFlowSum + cashSum
    actualReceive() {
      const billFlowSum = this.billFlowSum || 0;
      const cashSum = this.cashSum || 0;
      return billFlowSum + cashSum;
    },
    // 本次增加余额 addRest confirmReceive - shouldReceiveTotal
    addRest() {
      const confirmReceive = this.confirmReceive || 0;
      const shouldReceiveTotal = this.shouldReceiveTotal || 0;
      const ret = confirmReceive - shouldReceiveTotal;
      return Math.max(ret, 0);
    },
    // 剩余租赁余额 restRentAmount countData.balance - |rentRest| + addRest
    restRentAmount() {
      const balance = this.balance || 0;
      const rentRest = Math.abs(this.rentRest || 0);
      const addRest = this.addRest || 0;
      const ret = balance - rentRest + addRest;
      return Math.max(ret, 0);
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 添加应收账款
    addAccount() { },
    // 删除
    del(scope) {
      this.$emit('del', scope.$index);
    },
    edit() { },
    relative() { },
    detail() { }
  },
  created() { },
  mounted() {
    this.getDictionaryCodeValue('payment_class');
  }
};
</script>

<style lang="scss">
</style>
